import { ForwardRefComponent } from 'framer-motion';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Button, ButtonProps } from '~/shared/components';
import { CountBadge } from '~/features/productList/components/CountBadge';
import styles from '../FilterList.module.scss';

type BaseFilterDropdownButtonProps = React.PropsWithChildren<unknown> &
    Pick<ButtonProps, 'onClick' | 'disabled'>;

export type FilterDropdownButtonProps = BaseFilterDropdownButtonProps & {
    isOpen?: boolean;
    label?: string;
    count?: number;
};
type FilterDropdownToggleButtonProps = FilterDropdownButtonProps & {
    isActive?: boolean;
};

export const FilterDropdownButton: ForwardRefComponent<
    HTMLButtonElement,
    FilterDropdownButtonProps
> = forwardRef((props: FilterDropdownButtonProps, ref) => {
    const { label, isOpen, count, children, ...rest } = props;

    return (
        <Button
            className={styles.filterToggleButton}
            aria-label={label}
            aria-expanded={isOpen}
            aria-controls={`filter_${label}`}
            small
            variant="inverse-plp"
            {...rest}
            ref={ref}
        >
            <span style={{ whiteSpace: 'nowrap' }}>{children}</span>
            {!!count && <CountBadge count={count} />}
        </Button>
    );
});

export const FilterToggleDropdownButton = (props: FilterDropdownToggleButtonProps) => {
    const { label, isOpen, children, ...rest } = props;

    return (
        <Button
            className={clsx(styles.filterToggleButton, { [styles.isActive]: props.isActive })}
            aria-label={label}
            aria-expanded={isOpen}
            aria-controls={`filter_${label}`}
            small
            variant="inverse-plp"
            {...rest}
        >
            <span style={{ whiteSpace: 'nowrap' }}>{children}</span>
        </Button>
    );
};
